/**
 * 불러톡 채팅방 목록 (/adm/chat/room) — 좌측 메뉴 「불러톡」 인라인 패널(iframe) 안, 또는 단독 창
 * ($j.Pages.Admin.ChatRoomList / body data-page-name="ChatRoomList")
 */
export default class ChatRoomList {
    initialize() {
        // 대화창(자식 창)에서 답변 전송 시 opener 로 호출한다 — F/Chat/Ajax.js. 창 사이 약속이라 window 에 둔다
        window.clearChatUnread = function (roomno) {
            $('.chat-list__avatar[data-value="' + roomno + '"]').closest('.chat-list__item').find('.chat-list__badge').remove();
        };

        // 방을 누르면 대화창 — 이탈 직전 스크롤도 저장
        $(document).on('click', '.chat-list__item', function () {
            saveChatListScroll();
            tarLinkTo($(this).data('href'));
        });
        // 검색해제 — 검색어를 비우고 다시 싣는다
        $('.chat-list__search-clear').on('click', function () {
            $('input[name=q]', this.form).val('');
            this.form.submit();
        });

        function tarLinkTo(adr) {
            // 인라인 패널(iframe) 안에서는 새창 대신 같은 프레임에서 대화창 열기
            if (window.self !== window.top) {
                document.location.href = adr;
                return;
            }
            // 목록을 단독 창으로 열어 둔 경우 — 현재 창 바로 오른쪽에 대화창을 붙여 띄운다
            var w = 450, h = window.outerHeight || 600; // 높이는 현재 창과 동일
            var baseLeft = (window.screenLeft !== undefined) ? window.screenLeft : window.screenX;
            var baseTop  = (window.screenTop  !== undefined) ? window.screenTop  : window.screenY;
            var feats = 'toolbar=no,status=no,directories=no,scrollbars=yes,location=no,resizable=yes,menubar=no'
                      + ',width=' + w + ',height=' + h + ',left=' + (baseLeft + window.outerWidth) + ',top=' + baseTop;
            var win2 = window.open(adr, 'pcadminChat', feats);
            if (win2) win2.focus();
        }

        function goChatList(date) {
            $('input[name="date"]').val(date);
            $('#form1').submit();
        }

        // ── 목록 스크롤 위치 저장/복원 + 맨위로 버튼 ──
        //   방으로 들어갔다가 ESC(또는 뒤로가기)로 목록에 복귀하면 목록이 통째로 다시 실려
        //   맨 위로 튀던 문제를 해결. 이탈 직전 스크롤 위치를 sessionStorage 에 저장하고
        //   같은 날짜/검색어의 목록이 다시 뜨면 그 위치로 복원한다.
        function chatListScrollKey() {
            var date = $('#date').val() || '';
            var q = $('input[name=q]').val() || '';
            return 'admChatListScroll:' + date + '|' + q;
        }
        function saveChatListScroll() {
            try { sessionStorage.setItem(chatListScrollKey(), String(window.scrollY || 0)); } catch (e) {}
        }
        function restoreChatListScroll() {
            try {
                var y = parseInt(sessionStorage.getItem(chatListScrollKey()) || '0', 10);
                if (y > 0) window.scrollTo(0, y);
            } catch (e) {}
        }

        // 복원 먼저 (렌더 직후 이전 스크롤 위치로)
        restoreChatListScroll();
        // 페이지 이탈 시 현재 스크롤 저장
        window.addEventListener('beforeunload', saveChatListScroll);

        // 맨위로 버튼: 조금이라도 스크롤하면 노출, 클릭 시 최상단으로
        var $topBtn = $('#chatListTop');
        function onChatListScroll() {
            if ((window.scrollY || 0) > 60) $topBtn.addClass('show');
            else $topBtn.removeClass('show');
        }
        window.addEventListener('scroll', onChatListScroll, { passive: true });
        $topBtn.on('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
        onChatListScroll();

        // 아바타(회원코드)를 누르면 기사관리 포털을 현재 창 바로 옆에 연다.
        // 회원 불러톡은 열지 않는다 — 대리진입한 관리자는 못 들어간다(Mobile\ChatController::blockedForProxy).
        $('.mb_circle').on('click', function (e) {
            e.stopPropagation();
            $j.F.Admin.Util.memberPortal($(this).attr('data-value'), '', true);
        });

        $('#date').mobiscroll().datepicker({
            controls: ['calendar'],
            dateFormat: 'YYYY-MM-DD',
            locale: mobiscroll.localeKo,
            themeVariant: document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light', // 관리자 화면모드에 맞춰 피커 다크
            touchUi: false,
            width: '100%',
            renderCalendarHeader: $j.Common.Mobiscroll.HEADER_PLAIN,  // 칸 클릭으로 이동 — 내장 '오늘'은 반영이 안 돼 뺀다
            onCellClick: function (args, inst) {
                if (!args.date) return;
                const date = dayjs(args.date).format('YYYY-MM-DD');
                if (args.outer) {
                    // 다른 월의 날짜 — 월 이동을 강제한 뒤 선택 (모바일 환경 지연 처리)
                    inst.navigate(args.date);
                    setTimeout(() => { inst.setVal(args.date, true); goChatList(date); }, 1);
                } else {
                    inst.setVal(args.date, true);
                    goChatList(date);
                }
            },
        });
    }
}
